// extracted by css-extract-rspack-plugin
module.exports =  {"layout":"KeyboardLayout-d5yv__layout","key-group":"KeyboardLayout-fJGF__key-group","key":"KeyboardLayout-Kgk5__key","key--actived":"KeyboardLayout-THM6__key--actived"};